import { createFileRoute } from "@tanstack/react-router";

import ObservabilityAdmin from "@/components/ObservabilityAdmin";

// Generated to match `src/app/admin/observability/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/observability")({
  component: ObservabilityAdmin,
});
